import React from 'react';
import clsx from 'clsx';
import MaterialDialog from '@material-ui/core/Dialog';
import MaterialDialogTitle from '@material-ui/core/DialogTitle';
import MaterialDialogContent from '@material-ui/core/DialogContent';
import MaterialDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@assets/icons/close.svg';
import useStyles from './style';

const DialogActions = props => {
  return <MaterialDialogActions>{props.children}</MaterialDialogActions>;
};

const DialogTitle = props => {
  const classes = useStyles();
  const handleClose = () => {
    props.onCloseInternal();

    if (props.onClose) {
      props.onClose();
    }
  };

  return (
    <MaterialDialogTitle
      classes={{
        root: clsx(props.className, classes.title),
      }}
    >
      {props.children}
      {props.hasClose && (
        <IconButton
          aria-label='close'
          onClick={handleClose}
          className={clsx('p-absolute', classes.closeIcon)}
        >
          <img alt='Close icon' src={props.closeIcon || CloseIcon} />
        </IconButton>
      )}
    </MaterialDialogTitle>
  );
};

const DialogContent = props => {
  return (
    <MaterialDialogContent className={props.className}>
      {props.children}
    </MaterialDialogContent>
  );
};

const Dialog = props => {
  let Children = [];

  props.children.forEach((child, childIndex) => {
    if (child.type === DialogTitle) {
      Children.push(
        React.cloneElement(child, {
          key: `dialog-child-${childIndex}`,
          onCloseInternal: props.onClose || (() => {}),
        })
      );
    } else {
      Children.push(
        React.cloneElement(child, { key: `dialog-child-${childIndex}` })
      );
    }
  });

  return (
    <MaterialDialog
      {...props}
      onClose={props.onClose}
      open={props.open}
      className={props.className}
      classes={props.classes}
    >
      {Children}
    </MaterialDialog>
  );
};

Dialog.Title = DialogTitle;
Dialog.Content = DialogContent;
Dialog.Actions = DialogActions;

export default Dialog;
